import { useEffect } from "react";
import Lenis from "lenis";
import "@/index.css";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { EditorialMarquee } from "@/components/site/Marquee";
import { Problem } from "@/components/site/Problem";
import { Trades } from "@/components/site/Trades";
import { MessagingFirst } from "@/components/site/Messaging";
import { Projects } from "@/components/site/Projects";
import { Automation } from "@/components/site/Automation";
import { Approvals, Tasks, MediaSearch, OutOfHours } from "@/components/site/Features";
import { Business } from "@/components/site/Business";
import { Pricing } from "@/components/site/Pricing";
import { Trust } from "@/components/site/Trust";
import { HowItWorks } from "@/components/site/HowItWorks";
import { FAQ } from "@/components/site/FAQ";
import { FinalCTA } from "@/components/site/FinalCTA";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { PaymentResult } from "@/components/site/PaymentResult";
import { LegalPage } from "@/components/site/Legal";

function App() {
  const path = window.location.pathname;
  const paymentPage = path.startsWith("/payment/success")
    ? "success"
    : path.startsWith("/payment/cancel")
      ? "cancel"
      : null;
  const legalPage = ["/privacy", "/terms", "/cookies"].includes(path) ? path.slice(1) : null;

  useEffect(() => {
    if (paymentPage || legalPage) return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, [paymentPage, legalPage]);

  if (paymentPage) {
    return <PaymentResult kind={paymentPage} />;
  }

  if (legalPage) {
    return <LegalPage doc={legalPage} />;
  }

  return (
    <div className="grain bg-white min-h-screen" data-testid="diem-homepage">
      <Nav />
      <main>
        <Hero />
        <EditorialMarquee />
        <Problem />
        <Trades />
        <MessagingFirst />
        <Projects />
        <Automation />
        <Approvals />
        <Tasks />
        <MediaSearch />
        <OutOfHours />
        <Business />
        <Pricing />
        <Trust />
        <HowItWorks />
        <FAQ />
        <FinalCTA />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
